module.exports = __webpack_public_path__ + "img/rosepetal-dep-escuris.4a49b767.jpg";